/**
 * ISO 3166 country calling codes for phone OTP verification (TP-451).
 * Generated from country-telephone-data; do not hand-edit the COUNTRIES array.
 */

import { NSN_LENGTH_BY_ISO, NSN_LENGTH_RANGE_BY_ISO } from './nationalLengths';

export const COUNTRIES = [
  {
    iso: 'AF',
    name: 'Afghanistan',
    dial: '93',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AX',
    name: 'Åland Islands',
    dial: '358',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AL',
    name: 'Albania',
    dial: '355',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'DZ',
    name: 'Algeria',
    dial: '213',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AS',
    name: 'American Samoa',
    dial: '1684',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AD',
    name: 'Andorra',
    dial: '376',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AO',
    name: 'Angola',
    dial: '244',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AI',
    name: 'Anguilla',
    dial: '1264',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AQ',
    name: 'Antarctica',
    dial: '672',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AG',
    name: 'Antigua and Barbuda',
    dial: '1268',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AR',
    name: 'Argentina',
    dial: '54',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AM',
    name: 'Armenia',
    dial: '374',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AW',
    name: 'Aruba',
    dial: '297',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AU',
    name: 'Australia',
    dial: '61',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AT',
    name: 'Austria',
    dial: '43',
    aliases: ['osterreich'],
    priority: 0,
  },
  {
    iso: 'AZ',
    name: 'Azerbaijan',
    dial: '994',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BS',
    name: 'Bahamas',
    dial: '1242',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BH',
    name: 'Bahrain',
    dial: '973',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BD',
    name: 'Bangladesh',
    dial: '880',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BB',
    name: 'Barbados',
    dial: '1246',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BY',
    name: 'Belarus',
    dial: '375',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BE',
    name: 'Belgium',
    dial: '32',
    aliases: ['belgie', 'belgique'],
    priority: 0,
  },
  {
    iso: 'BZ',
    name: 'Belize',
    dial: '501',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BJ',
    name: 'Benin',
    dial: '229',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BM',
    name: 'Bermuda',
    dial: '1441',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BT',
    name: 'Bhutan',
    dial: '975',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BO',
    name: 'Bolivia',
    dial: '591',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BA',
    name: 'Bosnia and Herzegovina',
    dial: '387',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BW',
    name: 'Botswana',
    dial: '267',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BV',
    name: 'Bouvet Island',
    dial: '47',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BR',
    name: 'Brazil',
    dial: '55',
    aliases: ['brasil'],
    priority: 0,
  },
  {
    iso: 'IO',
    name: 'British Indian Ocean Territory',
    dial: '246',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'VG',
    name: 'British Virgin Islands',
    dial: '1284',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BN',
    name: 'Brunei',
    dial: '673',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BG',
    name: 'Bulgaria',
    dial: '359',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BF',
    name: 'Burkina Faso',
    dial: '226',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BI',
    name: 'Burundi',
    dial: '257',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'KH',
    name: 'Cambodia',
    dial: '855',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CM',
    name: 'Cameroon',
    dial: '237',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CA',
    name: 'Canada',
    dial: '1',
    aliases: [],
    priority: 1,
  },
  {
    iso: 'CV',
    name: 'Cape Verde',
    dial: '238',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BQ',
    name: 'Caribbean Netherlands',
    dial: '599',
    aliases: [],
    priority: 1,
  },
  {
    iso: 'KY',
    name: 'Cayman Islands',
    dial: '1345',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CF',
    name: 'Central African Republic',
    dial: '236',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TD',
    name: 'Chad',
    dial: '235',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CL',
    name: 'Chile',
    dial: '56',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CN',
    name: 'China',
    dial: '86',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CX',
    name: 'Christmas Island',
    dial: '61',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CC',
    name: 'Cocos (Keeling) Islands',
    dial: '61',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CO',
    name: 'Colombia',
    dial: '57',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'KM',
    name: 'Comoros',
    dial: '269',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CD',
    name: 'Congo (DRC)',
    dial: '243',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CG',
    name: 'Congo (Republic)',
    dial: '242',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CK',
    name: 'Cook Islands',
    dial: '682',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CR',
    name: 'Costa Rica',
    dial: '506',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CI',
    name: 'Côte d’Ivoire',
    dial: '225',
    aliases: ['ivory coast'],
    priority: 0,
  },
  {
    iso: 'HR',
    name: 'Croatia',
    dial: '385',
    aliases: ['hrvatska'],
    priority: 0,
  },
  {
    iso: 'CU',
    name: 'Cuba',
    dial: '53',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CW',
    name: 'Curaçao',
    dial: '599',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CY',
    name: 'Cyprus',
    dial: '357',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'CZ',
    name: 'Czech Republic',
    dial: '420',
    aliases: ['czech republic'],
    priority: 0,
  },
  {
    iso: 'DK',
    name: 'Denmark',
    dial: '45',
    aliases: ['danmark'],
    priority: 0,
  },
  {
    iso: 'DJ',
    name: 'Djibouti',
    dial: '253',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'DM',
    name: 'Dominica',
    dial: '1767',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'DO',
    name: 'Dominican Republic',
    dial: '1',
    aliases: [],
    priority: 2,
  },
  {
    iso: 'EC',
    name: 'Ecuador',
    dial: '593',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'EG',
    name: 'Egypt',
    dial: '20',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SV',
    name: 'El Salvador',
    dial: '503',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GQ',
    name: 'Equatorial Guinea',
    dial: '240',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'ER',
    name: 'Eritrea',
    dial: '291',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'EE',
    name: 'Estonia',
    dial: '372',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'ET',
    name: 'Ethiopia',
    dial: '251',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'FK',
    name: 'Falkland Islands',
    dial: '500',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'FO',
    name: 'Faroe Islands',
    dial: '298',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'FJ',
    name: 'Fiji',
    dial: '679',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'FI',
    name: 'Finland',
    dial: '358',
    aliases: ['suomi'],
    priority: 0,
  },
  {
    iso: 'FR',
    name: 'France',
    dial: '33',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GF',
    name: 'French Guiana',
    dial: '594',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PF',
    name: 'French Polynesia',
    dial: '689',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TF',
    name: 'French Southern and Antarctic Lands',
    dial: '262',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GA',
    name: 'Gabon',
    dial: '241',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GM',
    name: 'Gambia',
    dial: '220',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GE',
    name: 'Georgia',
    dial: '995',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'DE',
    name: 'Germany',
    dial: '49',
    aliases: ['deutschland'],
    priority: 0,
  },
  {
    iso: 'GH',
    name: 'Ghana',
    dial: '233',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GI',
    name: 'Gibraltar',
    dial: '350',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GR',
    name: 'Greece',
    dial: '30',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GL',
    name: 'Greenland',
    dial: '299',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GD',
    name: 'Grenada',
    dial: '1473',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GP',
    name: 'Guadeloupe',
    dial: '590',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GU',
    name: 'Guam',
    dial: '1671',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GT',
    name: 'Guatemala',
    dial: '502',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GG',
    name: 'Guernsey',
    dial: '44',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GN',
    name: 'Guinea',
    dial: '224',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GW',
    name: 'Guinea-Bissau',
    dial: '245',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'GY',
    name: 'Guyana',
    dial: '592',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'HT',
    name: 'Haiti',
    dial: '509',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'HM',
    name: 'Heard Island and McDonald Islands',
    dial: '672',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'HN',
    name: 'Honduras',
    dial: '504',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'HK',
    name: 'Hong Kong',
    dial: '852',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'HU',
    name: 'Hungary',
    dial: '36',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'IS',
    name: 'Iceland',
    dial: '354',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'IN',
    name: 'India',
    dial: '91',
    aliases: ['bharat'],
    priority: 0,
  },
  {
    iso: 'ID',
    name: 'Indonesia',
    dial: '62',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'IR',
    name: 'Iran',
    dial: '98',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'IQ',
    name: 'Iraq',
    dial: '964',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'IE',
    name: 'Ireland',
    dial: '353',
    aliases: ['eire'],
    priority: 0,
  },
  {
    iso: 'IM',
    name: 'Isle of Man',
    dial: '44',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'IL',
    name: 'Israel',
    dial: '972',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'IT',
    name: 'Italy',
    dial: '39',
    aliases: ['italia'],
    priority: 0,
  },
  {
    iso: 'JM',
    name: 'Jamaica',
    dial: '1876',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'JP',
    name: 'Japan',
    dial: '81',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'JE',
    name: 'Jersey',
    dial: '44',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'JO',
    name: 'Jordan',
    dial: '962',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'KZ',
    name: 'Kazakhstan',
    dial: '7',
    aliases: [],
    priority: 1,
  },
  {
    iso: 'KE',
    name: 'Kenya',
    dial: '254',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'KI',
    name: 'Kiribati',
    dial: '686',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'XK',
    name: 'Kosovo',
    dial: '383',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'KW',
    name: 'Kuwait',
    dial: '965',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'KG',
    name: 'Kyrgyzstan',
    dial: '996',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LA',
    name: 'Laos',
    dial: '856',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LV',
    name: 'Latvia',
    dial: '371',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LB',
    name: 'Lebanon',
    dial: '961',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LS',
    name: 'Lesotho',
    dial: '266',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LR',
    name: 'Liberia',
    dial: '231',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LY',
    name: 'Libya',
    dial: '218',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LI',
    name: 'Liechtenstein',
    dial: '423',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LT',
    name: 'Lithuania',
    dial: '370',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LU',
    name: 'Luxembourg',
    dial: '352',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MO',
    name: 'Macau',
    dial: '853',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MK',
    name: 'Macedonia (FYROM)',
    dial: '389',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MG',
    name: 'Madagascar',
    dial: '261',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MW',
    name: 'Malawi',
    dial: '265',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MY',
    name: 'Malaysia',
    dial: '60',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MV',
    name: 'Maldives',
    dial: '960',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'ML',
    name: 'Mali',
    dial: '223',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MT',
    name: 'Malta',
    dial: '356',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MH',
    name: 'Marshall Islands',
    dial: '692',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MQ',
    name: 'Martinique',
    dial: '596',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MR',
    name: 'Mauritania',
    dial: '222',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MU',
    name: 'Mauritius',
    dial: '230',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'YT',
    name: 'Mayotte',
    dial: '262',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MX',
    name: 'Mexico',
    dial: '52',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'FM',
    name: 'Micronesia',
    dial: '691',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MD',
    name: 'Moldova',
    dial: '373',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MC',
    name: 'Monaco',
    dial: '377',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MN',
    name: 'Mongolia',
    dial: '976',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'ME',
    name: 'Montenegro',
    dial: '382',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MS',
    name: 'Montserrat',
    dial: '1664',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MA',
    name: 'Morocco',
    dial: '212',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MZ',
    name: 'Mozambique',
    dial: '258',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MM',
    name: 'Myanmar (Burma)',
    dial: '95',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NA',
    name: 'Namibia',
    dial: '264',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NR',
    name: 'Nauru',
    dial: '674',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NP',
    name: 'Nepal',
    dial: '977',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NL',
    name: 'Netherlands',
    dial: '31',
    aliases: ['holland', 'nederland'],
    priority: 0,
  },
  {
    iso: 'NC',
    name: 'New Caledonia',
    dial: '687',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NZ',
    name: 'New Zealand',
    dial: '64',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NI',
    name: 'Nicaragua',
    dial: '505',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NE',
    name: 'Niger',
    dial: '227',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NG',
    name: 'Nigeria',
    dial: '234',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NU',
    name: 'Niue',
    dial: '683',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NF',
    name: 'Norfolk Island',
    dial: '672',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'KP',
    name: 'North Korea',
    dial: '850',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MP',
    name: 'Northern Mariana Islands',
    dial: '1670',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'NO',
    name: 'Norway',
    dial: '47',
    aliases: ['norge'],
    priority: 0,
  },
  {
    iso: 'OM',
    name: 'Oman',
    dial: '968',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PK',
    name: 'Pakistan',
    dial: '92',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PW',
    name: 'Palau',
    dial: '680',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PS',
    name: 'Palestine',
    dial: '970',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PA',
    name: 'Panama',
    dial: '507',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PG',
    name: 'Papua New Guinea',
    dial: '675',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PY',
    name: 'Paraguay',
    dial: '595',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PE',
    name: 'Peru',
    dial: '51',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PH',
    name: 'Philippines',
    dial: '63',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PN',
    name: 'Pitcairn Islands',
    dial: '64',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PL',
    name: 'Poland',
    dial: '48',
    aliases: ['polska'],
    priority: 0,
  },
  {
    iso: 'PT',
    name: 'Portugal',
    dial: '351',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'PR',
    name: 'Puerto Rico',
    dial: '1',
    aliases: [],
    priority: 3,
  },
  {
    iso: 'QA',
    name: 'Qatar',
    dial: '974',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'RE',
    name: 'Réunion',
    dial: '262',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'RO',
    name: 'Romania',
    dial: '40',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'RU',
    name: 'Russia',
    dial: '7',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'RW',
    name: 'Rwanda',
    dial: '250',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'BL',
    name: 'Saint Barthélemy',
    dial: '590',
    aliases: [],
    priority: 1,
  },
  {
    iso: 'SH',
    name: 'Saint Helena',
    dial: '290',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'KN',
    name: 'Saint Kitts and Nevis',
    dial: '1869',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'LC',
    name: 'Saint Lucia',
    dial: '1758',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'MF',
    name: 'Saint Martin (Saint-Martin (partie française))',
    dial: '590',
    aliases: [],
    priority: 2,
  },
  {
    iso: 'PM',
    name: 'Saint Pierre and Miquelon',
    dial: '508',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'VC',
    name: 'Saint Vincent and the Grenadines',
    dial: '1784',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'WS',
    name: 'Samoa',
    dial: '685',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SM',
    name: 'San Marino',
    dial: '378',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'ST',
    name: 'São Tomé and Príncipe',
    dial: '239',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SA',
    name: 'Saudi Arabia',
    dial: '966',
    aliases: ['ksa'],
    priority: 0,
  },
  {
    iso: 'SN',
    name: 'Senegal',
    dial: '221',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'RS',
    name: 'Serbia',
    dial: '381',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SC',
    name: 'Seychelles',
    dial: '248',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SL',
    name: 'Sierra Leone',
    dial: '232',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SG',
    name: 'Singapore',
    dial: '65',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SX',
    name: 'Sint Maarten',
    dial: '1721',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SK',
    name: 'Slovakia',
    dial: '421',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SI',
    name: 'Slovenia',
    dial: '386',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SB',
    name: 'Solomon Islands',
    dial: '677',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SO',
    name: 'Somalia',
    dial: '252',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'ZA',
    name: 'South Africa',
    dial: '27',
    aliases: ['rsa'],
    priority: 0,
  },
  {
    iso: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    dial: '500',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'KR',
    name: 'South Korea',
    dial: '82',
    aliases: ['korea'],
    priority: 0,
  },
  {
    iso: 'SS',
    name: 'South Sudan',
    dial: '211',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'ES',
    name: 'Spain',
    dial: '34',
    aliases: ['espana'],
    priority: 0,
  },
  {
    iso: 'LK',
    name: 'Sri Lanka',
    dial: '94',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SD',
    name: 'Sudan',
    dial: '249',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SR',
    name: 'Suriname',
    dial: '597',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SJ',
    name: 'Svalbard and Jan Mayen',
    dial: '47',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SZ',
    name: 'Swaziland',
    dial: '268',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'SE',
    name: 'Sweden',
    dial: '46',
    aliases: ['sverige'],
    priority: 0,
  },
  {
    iso: 'CH',
    name: 'Switzerland',
    dial: '41',
    aliases: ['schweiz', 'suisse'],
    priority: 0,
  },
  {
    iso: 'SY',
    name: 'Syria',
    dial: '963',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TW',
    name: 'Taiwan',
    dial: '886',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TJ',
    name: 'Tajikistan',
    dial: '992',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TZ',
    name: 'Tanzania',
    dial: '255',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TH',
    name: 'Thailand',
    dial: '66',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TL',
    name: 'Timor-Leste',
    dial: '670',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TG',
    name: 'Togo',
    dial: '228',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TK',
    name: 'Tokelau',
    dial: '690',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TO',
    name: 'Tonga',
    dial: '676',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TT',
    name: 'Trinidad and Tobago',
    dial: '1868',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TN',
    name: 'Tunisia',
    dial: '216',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TR',
    name: 'Turkey',
    dial: '90',
    aliases: ['turkey'],
    priority: 0,
  },
  {
    iso: 'TM',
    name: 'Turkmenistan',
    dial: '993',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TC',
    name: 'Turks and Caicos Islands',
    dial: '1649',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'TV',
    name: 'Tuvalu',
    dial: '688',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'VI',
    name: 'U.S. Virgin Islands',
    dial: '1340',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'UG',
    name: 'Uganda',
    dial: '256',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'UA',
    name: 'Ukraine',
    dial: '380',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'AE',
    name: 'United Arab Emirates',
    dial: '971',
    aliases: ['uae', 'dubai', 'abu dhabi'],
    priority: 0,
  },
  {
    iso: 'GB',
    name: 'United Kingdom',
    dial: '44',
    aliases: [
      'uk',
      'britain',
      'great britain',
      'england',
      'scotland',
      'wales',
      'northern ireland',
    ],
    priority: 0,
  },
  {
    iso: 'US',
    name: 'United States',
    dial: '1',
    aliases: ['usa', 'us', 'america'],
    priority: 0,
  },
  {
    iso: 'UM',
    name: 'United States Minor Outlying Islands',
    dial: '1',
    aliases: [],
    priority: 2,
  },
  {
    iso: 'UY',
    name: 'Uruguay',
    dial: '598',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'UZ',
    name: 'Uzbekistan',
    dial: '998',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'VU',
    name: 'Vanuatu',
    dial: '678',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'VA',
    name: 'Vatican City',
    dial: '39',
    aliases: [],
    priority: 1,
  },
  {
    iso: 'VE',
    name: 'Venezuela',
    dial: '58',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'VN',
    name: 'Vietnam',
    dial: '84',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'WF',
    name: 'Wallis and Futuna',
    dial: '681',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'EH',
    name: 'Western Sahara',
    dial: '212',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'YE',
    name: 'Yemen',
    dial: '967',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'ZM',
    name: 'Zambia',
    dial: '260',
    aliases: [],
    priority: 0,
  },
  {
    iso: 'ZW',
    name: 'Zimbabwe',
    dial: '263',
    aliases: [],
    priority: 0,
  },
];

/** Preferred ISO when multiple territories share a dial code. */
export const MAIN_ISO_FOR_DIAL = {
  1: 'US',
  7: 'RU',
  44: 'GB',
};

export const COUNTRIES_BY_ISO = COUNTRIES.reduce((acc, country) => {
  acc[country.iso] = country;
  return acc;
}, {});

export function flagUrl(iso) {
  if (!iso) return '';
  return `https://flagcdn.com/${String(iso).toLowerCase()}.svg`;
}

export function normalizeSearch(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

/**
 * Search countries by name, ISO, alias, or dial code (+44 / 44).
 */
export function searchCountries(rawQuery) {
  const q = normalizeSearch(rawQuery).trim();
  if (!q) return COUNTRIES.slice();

  const num = q.replace(/^\+/, '');
  const isNum = /^\d+$/.test(num);
  const scored = [];

  for (let i = 0; i < COUNTRIES.length; i += 1) {
    const c = COUNTRIES[i];
    const key = normalizeSearch(c.name);
    let score = -1;

    if (isNum) {
      if (c.dial === num) {
        score = MAIN_ISO_FOR_DIAL[num] === c.iso ? 0 : 1;
      } else if (c.dial.indexOf(num) === 0) {
        score = 2;
      }
    } else if (key.indexOf(q) === 0 || c.iso.toLowerCase() === q) {
      score = 0;
    } else if (
      key.split(/[\s-]+/).some((w) => w.indexOf(q) === 0) ||
      (c.aliases || []).some((a) => normalizeSearch(a).indexOf(q) === 0)
    ) {
      score = 1;
    } else if (q.length > 2 && key.indexOf(q) !== -1) {
      score = 2;
    }

    if (score >= 0) {
      scored.push({ c, score });
    }
  }

  scored.sort((a, b) => {
    if (a.score !== b.score) return a.score - b.score;
    return a.c.name.localeCompare(b.c.name);
  });

  return scored.map((x) => x.c);
}

/**
 * Resolve initial country ISO from saved phone, user location, browser locale, then GB.
 */
export function resolveInitialCountryIso(user) {
  if (user && user.phone) {
    const fromPhone = parseInternationalNumber(user.phone);
    if (fromPhone) return fromPhone.iso;
  }

  const fromUser = user && user.location && user.location.country_code;
  if (fromUser) {
    const iso = String(fromUser).toUpperCase().replace(/^UK$/, 'GB');
    if (COUNTRIES_BY_ISO[iso]) return iso;
  }

  if (typeof navigator !== 'undefined' && navigator.language) {
    const parts = String(navigator.language).split('-');
    if (parts.length > 1) {
      const iso = parts[parts.length - 1].toUpperCase().replace(/^UK$/, 'GB');
      if (COUNTRIES_BY_ISO[iso]) return iso;
    }
  }

  return 'GB';
}

/**
 * Initial country + national digits for the OTP number step.
 * Prefills from a saved account phone (E.164) when present.
 */
export function resolveInitialPhoneFields(user) {
  if (user && user.phone) {
    const hit = parseInternationalNumber(user.phone);
    if (hit && hit.national) {
      return { iso: hit.iso, phone: hit.national };
    }
  }
  return { iso: resolveInitialCountryIso(user), phone: '' };
}

/**
 * API / TP-449 E.164 shape: leading +, country code, subscriber number
 * (7–15 digits total after +). See StoreRequest phone.regex.
 */
export const E164_PATTERN = /^\+[1-9]\d{6,14}$/;

/**
 * Fallback minimum national digits when a country has no format mask.
 * Prefer {@link expectedNationalLength} (e.g. GB/US = 10).
 */
export const MIN_NATIONAL_DIGITS = 7;

/**
 * Expected national significant number length for an ISO country.
 * Shared dial codes without their own mask (JE/GG/IM on +44) inherit the
 * main territory length (GB → 10). Prefer {@link nationalLengthRange} when
 * validating input that may span a min/max range.
 */
export function expectedNationalLength(iso) {
  const upper = String(iso || '').toUpperCase();
  if (NSN_LENGTH_BY_ISO[upper]) return NSN_LENGTH_BY_ISO[upper];

  const country = COUNTRIES_BY_ISO[upper];
  if (!country) return null;

  const mainIso = MAIN_ISO_FOR_DIAL[country.dial];
  if (mainIso && NSN_LENGTH_BY_ISO[mainIso]) return NSN_LENGTH_BY_ISO[mainIso];

  return null;
}

/**
 * Min/max national significant number length for an ISO country.
 * Uses explicit ranges when present; otherwise an exact expected length.
 */
export function nationalLengthRange(iso) {
  const upper = String(iso || '').toUpperCase();
  if (NSN_LENGTH_RANGE_BY_ISO[upper]) {
    return NSN_LENGTH_RANGE_BY_ISO[upper];
  }
  const expected = expectedNationalLength(upper);
  if (expected != null) {
    return { min: expected, max: expected };
  }
  return null;
}

/**
 * Build E.164 from ISO country + national digits.
 * Returns null when the number is incomplete or not E.164.
 */
export function assembleE164(iso, nationalNumber) {
  const country = COUNTRIES_BY_ISO[String(iso || '').toUpperCase()];
  const digits = String(nationalNumber || '').replace(/\D/g, '');
  if (!country || !digits) return null;

  // Drop a single leading trunk 0 when present (e.g. UK 07700… → 7700…)
  const national =
    digits.length > 1 && digits.charAt(0) === '0' ? digits.slice(1) : digits;

  const range = nationalLengthRange(iso);
  if (range) {
    if (national.length < range.min || national.length > range.max) {
      return null;
    }
  } else if (national.length < MIN_NATIONAL_DIGITS) {
    return null;
  }

  const e164 = `+${country.dial}${national}`;
  if (!E164_PATTERN.test(e164)) return null;
  return e164;
}

/**
 * Pick the best country for a matched dial-code prefix among shared codes.
 */
function countryForDialCode(code, matches) {
  const mainIso = MAIN_ISO_FOR_DIAL[code];
  if (mainIso && COUNTRIES_BY_ISO[mainIso]) {
    return COUNTRIES_BY_ISO[mainIso];
  }

  const priorityZero = matches.filter((c) => c.priority === 0);
  const withNsn = priorityZero.find(
    (c) => NSN_LENGTH_BY_ISO[c.iso] != null || NSN_LENGTH_RANGE_BY_ISO[c.iso]
  );
  if (withNsn) return withNsn;
  if (priorityZero.length) return priorityZero[0];
  return matches[0];
}

/**
 * Parse an international paste (e.g. +447700900123) into iso + national digits.
 * Longer dial-code prefixes (up to 4 digits) are matched before shorter ones.
 */
export function parseInternationalNumber(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return null;

  for (let len = 4; len >= 1; len -= 1) {
    const code = digits.slice(0, len);
    const matches = COUNTRIES.filter((c) => c.dial === code);
    if (!matches.length) continue;

    const hit = countryForDialCode(code, matches);
    if (hit) {
      return { iso: hit.iso, national: digits.slice(len) };
    }
  }
  return null;
}
